/**
 * GSAP Animation Helpers
 * This file contains helper methods to standardize GSAP animations
 * and replace legacy Scriptaculous Effect animations.
 */

class LegacyEffects {
	/**
	 * Fade in an element (equivalent to Effect.Appear)
	 */
	static appear(element, options = {}) {
		const duration = options.duration || 0.5;
		const delay = options.delay || 0;

		gsap.set(element, {
			display: null
		});

		const tween = gsap.fromTo(element, {
			autoAlpha: 0,
		}, {
			autoAlpha: 1,
			clearProps: 'opacity',
			duration: duration,
			delay: delay,
			onComplete: options.onComplete
		});

		return tween;
	}

	/**
	 * Fade out an element (equivalent to Effect.Fade)
	 */
	static fade(element, options = {}) {
		const duration = options.duration || 0.5;
		const delay = options.delay || 0;

		const tween = gsap.to(element, {
			autoAlpha: 0,
			display: 'none',
			clearProps: 'opacity',
			duration: duration,
			delay: delay,
			onComplete: options.onComplete
		});

		return tween;
	}

	/**
	 * Move an element (equivalent to Effect.Move)
	 */
	static move(element, options = {}) {
		const duration = options.duration || 0.5;
		const delay = options.delay || 0;
		const mode = options.mode || 'relative';
		const ease = options.ease || 'power1.out';
		
		let xValue, yValue;
		
		if (mode === 'relative') {
			xValue = `+=${options.x || 0}`;
			yValue = `+=${options.y || 0}`;
		} else {
			xValue = options.x || 0;
			yValue = options.y || 0;
		}
		
		const tween = gsap.to(element, {
			left: xValue,
			top: yValue,
			duration: duration,
			delay: delay,
			ease: ease,
			onStart: options.onStart,
			onComplete: options.onComplete
		});
		
		return tween;
	}

	/**
	 * Pulsate an element (equivalent to Effect.Pulsate)
	 */
	static pulsate(element, options = {}) {
		const pulses = options.pulses || 3;
		const duration = options.duration || 1.0;
		const pulseDuration = duration / (pulses * 2);
		
		const timeline = gsap.timeline({
			onComplete: options.onComplete
		});
		
		for (let i = 0; i < pulses; i++) {
			timeline.to(element, { opacity: 0.5, duration: pulseDuration });
			timeline.to(element, { opacity: 1, duration: pulseDuration });
		}
		
		return timeline;
	}

	/**
	 * Run multiple animations in parallel (equivalent to Effect.Parallel)
	 * @param {Function[]} animations - Array of animation functions to run
	 */
	static parallel(animations, options = {}) {
		const timeline = gsap.timeline({
			onComplete: options.onComplete
		});
		
		animations.forEach(animFn => {
			if (animFn) {
				// If it's position is not explicitly set, add at 0 to make them run in parallel
				if (options.queue !== 'end') {
					timeline.add(animFn, 0);
				} else {
					timeline.add(animFn);
				}
			}
		});
		
		return timeline;
	}
}
